export const POPULATION_TYPE_OPTIONS = [
  { value: "medicare", label: "Medicare" },
  { value: "medicaid", label: "Medicaid" },
  { value: "commercial", label: "Commercial" },
];

export const LANGUAGE_OPTIONS = [
  { value: "ENGLISH", label: "English" },
  { value: "SPANISH", label: "Spanish" },
];

export const POPULATION_TYPE_MULTI_OPTIONS = POPULATION_TYPE_OPTIONS.map((o) => ({
  id: o.value,
  name: o.value,
}));
